import classNames from "classnames";
import React from "react";
import "./SkeletonRow.scss";

/** Пропсы {@link SkeletonRow}. */
export interface SkeletonRowProps {
    /** Имя класса. */
    className?: string;
    /**
     * HTML-тег строки.
     * @default "div"
     */
    tagName?: keyof HTMLElementTagNameMap;
    /** Ширина строки в процентах относительно родителя. */
    widthInProcent?: number;
    style?: React.CSSProperties;
}

/**
 * Анимированная skeleton-полоска для placeholder-состояний списков и карточек.
 */
export const SkeletonRow: React.FC<SkeletonRowProps> = ({ className, widthInProcent, tagName = "div", style }) => {
    const Tag = tagName;
    return (
        <Tag
            className={classNames("skeleton_loader_row", className)}
            style={{ ...style, width: `${widthInProcent ?? 100}%` }}
        />
    );
};
